import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
//import { Doc } from '../../core/models/document.model';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
@Injectable({ providedIn: 'root' })
export class NotifService {
  private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
    bank: environment.apiBankUrl, 
    pgl: environment.apiPglUrl,
    smt: environment.apiSmtUrl,
  };
  private getBaseUrl(): string {
    const userType = this.getUserType();
    return this.apiUrls[userType??'smt']+'/notifications/';
  }
  private getUserType(): 'bank' | 'pgl' | 'smt' {
    const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
    if (!token) return 'smt';

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.type as 'bank' | 'pgl' | 'smt';
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'smt';
    }
  } 
    constructor(private http: HttpClient) { }
    public notifs = [];
    public notifs$ = new Subject<any[]>();
 

    getnotifs() {
      const baseUrl = this.getBaseUrl();
        this.http.get(`${baseUrl}`).subscribe(
          (notifs: any[]) => {
            if (notifs) {
              this.notifs = notifs;
              this.emitnotifs();
            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
    
      emitnotifs() {
        this.notifs$.next(this.notifs);
      }
    }